import { Code } from 'actions/actionTypes';

export const loadCodeListRequest = (codeGroup) => ({ type: Code.LOAD_CODE_LIST_REQUEST, payload: codeGroup });
export const loadCodeListSuccess = (responseData) => ({ type: Code.LOAD_CODE_LIST_SUCCESS, payload: responseData });
export const loadCodeListFailure = (errorMessage) => ({ type: Code.LOAD_CODE_LIST_FAILURE, payload: errorMessage });